import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SiteShell from "@/components/site/SiteShell";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Model from "@/pages/Model";
import Impact from "@/pages/Impact";
import Stories from "@/pages/Stories";
import Engage from "@/pages/Engage";
import Hub from "@/pages/Hub";
import Social from "@/pages/Social";
import Consult from "@/pages/Consult";
import Venture from "@/pages/Venture";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Contact from "@/pages/Contact";
import ProfileViewer from "@/pages/ProfileViewer";
import Publications from "@/pages/Publications";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <SiteShell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/model" element={<Model />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/engage" element={<Engage />} />
            <Route path="/iyaf-hub" element={<Hub />} />
            <Route path="/iyaf-social" element={<Social />} />
            <Route path="/iyaf-consult" element={<Consult />} />
            <Route path="/iyaf-venture" element={<Venture />} />
            <Route path="/open-opportunities" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<ProfileViewer />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SiteShell>
        <Toaster richColors position="bottom-center" />
      </BrowserRouter>
    </div>
  );
}
